export default __webpack_public_path__ + "static/media/ennovate_4.135b076e.jpg";